/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ifAuthenticated } from './../routeValidation';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Documents
const Permission = () =>
  import(
    /* webpackChunkName: "Permission" */ '@/views/Permissions/Permissions.vue'
  );

const newPermissionGroup = () =>
  import(
    /* webpackChunkName: "newPermissionGroup" */ '@/views/Permissions/newPermissionGroup.vue'
  );

const editPermissionGroup = () =>
  import(
    /* webpackChunkName: "editPermissionGroup" */ '@/views/Permissions/editPermissionGroup.vue'
  );

const permissionsPages = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  name: 'Permission',
  children: [
    {
      path: '/permisos',
      name: 'permissions',
      component: Permission,
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/permisos/nuevo-grupo',
      name: 'new-group-permission',
      component: newPermissionGroup,
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/permisos/editar/:permission_id',
      name: 'edit-group-permission',
      component: editPermissionGroup,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};

export default permissionsPages;
